/* eslint-disable max-len */
/* eslint-disable security/detect-unsafe-regex */

import React, { Fragment, useState, useEffect } from 'react';
import ItemShimmer from '../../../../../components/Shimmer/itemShimmer'
import Pagination from '../../../../../components/Pagination';

export default function SchemeStudentList({
    schemeStudentsData = [],
    sourceAccountId,
    sourceAccountNumber,
    studentListLoading,
    appliedAmts,
    setAppliedAmts,
    setToastErrorMessage,
    handleOnClickPageNumber,
    setSearchParams,
    searchParams,
    schemeStudentsTotalcount,
    setAppliedStudentsList,
    appliedStudentsList,
    state
}) {
    console.log('viewAppliedStudents', appliedStudentsList);

    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 50;
    const [suggestions, setSuggestions] = useState("");
    const [isClearVisible, setIsClearVisible] = useState(searchParams.get('search') || "" !== "");
    

    // Calculate total of all current amounts
    const totalCurrentAmt = Object.values(appliedAmts).reduce((sum, val) => sum + parseFloat(val || 0), 0);
    const totalPendingAmt = (sourceAccountNumber && !isNaN(parseFloat(sourceAccountNumber)) ? parseFloat(sourceAccountNumber) : 0) - totalCurrentAmt;

    useEffect(() => {
        const pages = Math.ceil(schemeStudentsTotalcount / itemsPerPage) || 1;
        if (pages !== totalPages) {
            setTotalPages(pages);
        }
    }, [schemeStudentsTotalcount, itemsPerPage, totalPages]);

    const clearIfValueIsZero = (index) => (e) => {
        // Only clear the value for the focused field, keep others as is
        if (Number(e.target.value) === 0 || e.target.value === '') {
            const newAmts = { ...appliedAmts };
            newAmts[index]='';
            setAppliedAmts(newAmts);
        }

        if (Object.keys(appliedStudentsList).length > 100) {
            setToastErrorMessage('Limit reached: Only 100 students can be applied at a time.');
        } else {
            setToastErrorMessage('');
        }
    };

    // On change: just update value
    const handleCurrentAmtChange = (value, idx) => {
        let val = value.trim();
        if (val?.length <= 13) {
            //val = val.replace(/[^0-9.]/g, '');
            const regex = /^(\d{1,10}(\.\d{0,2})?)?$/;
            if (regex.test(val)) {
                const newAmts = { ...appliedAmts };
                newAmts[idx] = val;
                if (parseFloat(val) === 0) {
                    delete newAmts[idx];
                }
                setAppliedAmts(newAmts);

                const student = schemeStudentsData.find(s => String(s.scheme_header_id) === String(idx));
                const filteredList = appliedStudentsList.filter(
                    s => String(s.scheme_header_id) !== String(idx)
                );

                if (student && parseFloat(val) !== 0) {
                    const studentDetails = {
                        student_name: student.student_name,
                        student_id: student.student_id,
                        scheme_header_id: student.scheme_header_id,
                        reference: student.receipt_number,
                        pending_amount: student.due_amount,
                        applied_amount: val
                    };
                    setAppliedStudentsList([...filteredList, studentDetails]);
                }
                setToastErrorMessage(''); // clear error while typing
            }
        }
    };

    const handleChange = (e) => {
        setSuggestions(e.target.value);
        setIsClearVisible(e.target.value !== "");
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            const params = Object.fromEntries(searchParams);
            setSearchParams({
                ...params,
                student_page_number: 1,
                search: suggestions,
            });
        }
    };

    const clearAndperformSearch = () => {
        setSuggestions("");
        setIsClearVisible(false);
        const params = Object.fromEntries(searchParams);
        delete params.search;
        setSearchParams({ ...params, student_page_number: 1 });
    };    

    // On blur: validate
    const setZeroIfEmpty = (index, pendingAmt) => (e) => {
        let value = e.target.value;
        let numVal = parseFloat(value);
        if (value.trim() === '' || isNaN(numVal)) {
            numVal = 0;
            value = '0.00';
        } else {
            value = numVal.toFixed(2);
        }

        const newAmts = { ...appliedAmts };
        newAmts[index] = value;
        const newTotal = Object.values(newAmts).reduce((sum, v) => sum + parseFloat(v || 0), 0);
        setAppliedAmts(newAmts);

        const student = schemeStudentsData.find(s => String(s.scheme_header_id) === String(index));
        // Remove any existing entry with the same scheme_header_id
        const filteredList = appliedStudentsList.filter(
            s => String(s.scheme_header_id) !== String(student.scheme_header_id)
        );
        if (student && parseFloat(value) !== 0) {
            const studentDetails = {
                student_name: student.student_name,
                student_id: student.student_id,
                scheme_header_id: student.scheme_header_id,
                reference: student.receipt_number,
                pending_amount: student.due_amount,
                applied_amount: value
            };
            setAppliedStudentsList([...filteredList, studentDetails]);
        }
        else{
            setAppliedStudentsList(filteredList);
        }
        
        // Validation: check against pending
        if (parseFloat(numVal) > parseFloat(pendingAmt)) {
            setToastErrorMessage(`Amt to Apply (${parseFloat(numVal).toFixed(2)}) cannot be more than Pending Amt (${parseFloat(pendingAmt).toFixed(2)}) for this student.`);
            return;
        } else {
            setToastErrorMessage('');
        }

        // Validation: check against ledger total
        
        if (newTotal > parseFloat(sourceAccountNumber)) {
            setToastErrorMessage('Total Applied Amt ('+parseFloat(newTotal).toFixed(2)+') cannot be more than Voucher Amount (' + parseFloat(sourceAccountNumber).toFixed(2) + ')');
        }
    };

    const handleReceiptClick = (collectFeeHeaderId) => {
        window.open(`/student-master/fee-collection/fee-collection-details/${collectFeeHeaderId}`, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className="overflow-auto scroll-bar min-h-minheight1 max-h-maxheight1 px-[40px] pt-4">
            <div className="flex justify-between items-center">
            </div>
            <div class="mb-6 p-3 border border-[#D0D5DD] rounded flex w-[820px] mx-auto">
                <div class="w-[40%] px-1">
                    <div class="flex mb-3">
                        <a class="min-w-[135px]" id="po_amount_label">Voucher Date</a>
                        <a class="font-semibold break-all w-[70%]" id="">{state.transaction_date}</a>
                    </div>
                    <div class="flex">
                        <a class="min-w-[135px]" id="po_amount_label">Voucher Amount</a>
                        <a class="font-semibold break-all w-[70%]" id="">{sourceAccountNumber}</a>
                    </div>
                </div>
                <div class="w-[60%] px-1 pl-[25px]">
                    <div class="flex mb-3">
                        <a class="w-[100%]" id="po_amount_label">
                            <span>Amount entered for {Object.keys(appliedStudentsList).length} student(s)</span>
                        </a>
                    </div>
                    <div class="flex">
                        <a class="w-[100%]" id="po_amount_label">Total Applied Amount: {totalCurrentAmt.toFixed(2)} | Remaining Amount: {totalPendingAmt.toFixed(2)}</a>
                    </div>
                </div>
            </div>
            <div className="flex justify-between items-center">
                <div className="flex justify-start"><p class="text-lg font-semibold text-[#000000]">Students List</p></div>
                <div className="flex justify-end">
                    <div className="relative search-tab">
                        <label htmlFor="input"></label>
                        <div className="absolute top-[52%] -translate-y-[50%]" id="search_button">
                            <button
                                type="button"
                                id="search-button"
                                className="inline-block"
                                data-te-toggle="modal"
                                data-te-target="#exampleModalCenter"
                                data-te-ripple-init
                                data-te-ripple-color="light"
                            >
                                <img
                                    loading="lazy"
                                    decoding="async"
                                    src="/images/search.svg"
                                    alt="img"
                                />
                            </button>
                        </div>
                        <div className="relative flex">
                            <input
                                maxLength={90}
                                type="text"
                                id="search-value"
                                autoComplete="off"
                                value={suggestions || searchParams.get('search') || ""}
                                autoFocus={suggestions !== ""}
                                onChange={handleChange}
                                onKeyPress={handleKeyPress}
                                placeholder="Student / Reference #"
                                style={{'width':'165px'}}
                            />
                        </div>
                        {isClearVisible && (
                            <div
                                className="absolute cross_icon"
                                id="clear_icon"
                                onClick={clearAndperformSearch}
                                title="Clear Search"
                            />
                        )}
                    </div>
                </div>
            </div>
            <div className='w-full mt-1'>
                <div className='mb-2 '>
                    {studentListLoading ? (
                        <ItemShimmer />
                    ) : (
                        <>
                            <table className="w-full table-auto greyHeader" id="admin-table">
                                <thead className='top-0 left-0 bg-white'>
                                    <tr className='student-th'>
                                        <th className="w-[25%]"><span className="flex items-center justify-start font-semibold pl-2">Student Name</span></th>
                                        <th className="w-[25%]"><span className="flex items-center justify-start font-semibold text-[#031624]">AY Details</span></th>
                                        <th className="w-[15%]"><span className="flex items-center justify-start font-semibold text-[#031624]">RET/SSh Ref #</span></th>                                        
                                        <th className="w-[15%]"><span className="flex justify-end font-semibold text-[#031624]">Claimed Amt</span></th>
                                        <th className="w-[15%]"><span className="flex justify-end font-semibold text-[#031624]">Pending Amt</span></th>
                                        <th className="w-[17%]"><span className="flex justify-end font-semibold text-[#031624]">Amount to Apply</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(schemeStudentsData) && schemeStudentsData.map((student, index) => (
                                        <Fragment key={student.student_uuid}>
                                            <tr>
                                                <td>
                                                    <div className='flex items-center '>
                                                        <p className='justify-start flex'>{student.student_name} [{student.student_id}]</p>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className="justify-start flex">{student.academic_year}, {student.class_name}</span>
                                                    <span className="justify-start flex">{student.section_name}</span>
                                                </td>
                                                <td>
                                                    <span className="justify-start flex text-[#106eb4] cursor-pointer" onClick={() => handleReceiptClick(student?.scheme_receipt_id)}>{student.receipt_number}</span>
                                                </td>
                                                <td>
                                                    <span className="justify-end flex">{parseFloat(student.scheme_amount).toFixed(2)}</span>
                                                </td>
                                                <td>
                                                    <span className="justify-end flex">{parseFloat(student.due_amount).toFixed(2)}</span>
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        maxlength={13}
                                                        autoComplete='off'
                                                        id={student.scheme_header_id + "_received_amount"}
                                                        data-testid = {"received_amount"}
                                                        className={`w-full text-end inpt-fld error_border`}
                                                        placeholder={`0.00`}
                                                        value={appliedAmts[student.scheme_header_id]}
                                                        onFocus={clearIfValueIsZero(student.scheme_header_id)}
                                                        onBlur={setZeroIfEmpty(student.scheme_header_id, student.due_amount)}
                                                        onChange={e => handleCurrentAmtChange(e.target.value, student.scheme_header_id)}
                                                    />
                                                </td>
                                            </tr>
                                        </Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </>)}
                    <table className="w-full table-auto greyHeader" id="admin-table">
                        <thead className='top-0 left-0 bg-white'>
                        </thead>
                        <tbody>
                            {Array.isArray(schemeStudentsData) && schemeStudentsData.length === 0 && sourceAccountId.trim() !== "" && <tr>
                                <td colSpan={6} className="no-records-message" id="no-matching-result" style={{ lineHeight: '100px' }}>No Students applicable for the selected ledger</td>
                            </tr>}
                            {(sourceAccountId === "" || sourceAccountId.trim() === "") && <tr>
                                <td colspan="6" class="no-records-message" id="no-matching-result" style={{ lineHeight: '100px' }}>Select RTE/Scholarship ledger under Source Account</td>
                            </tr>}
                        </tbody>
                    </table>
                </div>
                {schemeStudentsTotalcount > 50 && (
                    <Pagination
                        TotalCount={schemeStudentsTotalcount}
                        totalPageNumber={totalPages}
                        selectedPageNumber={Number(searchParams.get('student_page_number')) || 1}
                        handleOnClickPageNumber={handleOnClickPageNumber}
                        limit={itemsPerPage}
                    />
                )}
            </div>
        </div>
    );
}